import { useEffect, useState } from 'react';

import { CHATBOT_FAQ_PADDING, MOBILE_BREAKPOINT } from '#/utils/constants';

export function useResponsiveLayout(faqQuestionId, faqExpanded, contentRef, faqContainerRef, additionalNoteRef) {
  const [isResponsive, setIsResponsive] = useState(false);

  useEffect(() => {
    const resizeHandler = () => {
      const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

      setIsResponsive(window.innerWidth < MOBILE_BREAKPOINT && isMobile);

      const content = contentRef?.current;
      const faqContainer = faqContainerRef?.current;
      const additionalNote = additionalNoteRef?.current;

      if (content) {
        const height =
          window.innerHeight -
          (faqContainer?.clientHeight || 0) -
          (additionalNote?.clientHeight || 0) -
          CHATBOT_FAQ_PADDING;

        content.style.height = `${height}px`;
      }
    };

    window.addEventListener('resize', resizeHandler);
    resizeHandler();

    return () => window.removeEventListener('resize', resizeHandler);
  }, [faqQuestionId, faqExpanded]);

  useEffect(() => {
    const html = document.documentElement;

    if (isResponsive) {
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100vh';
      html.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      document.body.style.height = '';
      html.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.height = '';
      html.style.overflow = '';
    };
  }, [isResponsive]);

  return { isResponsive };
}
